import React, { Component, Fragment } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Link from '../../components/site/typography/Link'
import Button from '../../components/site/Button/Button'
import MenuItem from './MenuItem'
import PartnerContactModal from '../../components/site/Partner/PartnerContactModal'
import Picture from '../../components/Picture'
import { redirectWithCookies } from '../../utils/Utm'

import './Menu.scss'
import SiteNav from './SiteNav'

const softwareSubItems = [
        {
            href: '/industrias',
            title: 'Veja como o Mercos pode potencializar sua Indústria.',
            content: 'Indústrias',
            url: '/images/site/new-home/mercos-para-industrias.webp'
        },
        {
            href: '/distribuidoras',
            title: 'Veja como o Mercos pode potencializar sua Distribuidora.',
            content: 'Distribuidoras',
            url: '/images/site/new-home/mercos-para-distribuidoras.webp'
        },
        {
            href: '/representantes-comerciais',
            title: 'Veja como o Mercos pode potencializar o Representante Comercial.',
            content: 'Representantes',
            url: '/images/site/new-home/mercos-para-representantes-comerciais.webp'
        }
    ],
    partnersSubItems = [
        {
            href: '/integracao-erp',
            title: 'Encontre o ERP ideal com integração ao Mercos.',
            content: 'ERPs integrados'
        },
        {
            href: '/parceiros',
            title: 'Conheça nosso programa de Parceiros.',
            content: 'Seja parceiro'
        },
    ],
    conteudoSubItems = [
        {
            href: 'https://blog.mercos.com/',
            title: 'Novidades no blog',
            content: 'Blog',
            target: '_blank'
        },
        {
            href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI',
            title: 'Mercoscast',
            content: 'Mercoscast',
            target: '_blank'
        },
    ],
    participantsSubItems = [
        {
            href: '/experience/ingressos',
            title: 'Comprar agora meu ingresso.',
            content: 'Ingressos'
        },{
            href: '/experience/onde-ficar',
            title: 'Saiba onde ficar hospedado e quais as atividades da região.',
            content: 'Onde ficar'
        },{
            href: '/experience/duvidas',
            title: 'Tire suas dúvidas sobre o Mercos Experience.',
            content: 'Dúvidas'
        },
    ],
    videosSubItems = [
        {
            href: '/mercoscast',
            title: 'Ouça nosso podcast.',
            content: 'Mercoscast'
        },
        {
            href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hUoq30m-PK8Zx-S-lDYExX-',
            title: 'Veja nosso Mercos Minuto',
            content: 'Mercos Minuto',
            target: '_blank'
        },
        {
            href: '/blog/lives',
            title: 'Assista nossas lives',
            content: 'Lives'
        }
    ]

class Menu extends Component {
    constructor(props) {
        super(props)

        this.state = {
            openedMenu: false,
            whiteBackground: this.props.whiteBackground,
            compoundUtmUrl: '',
        }
    }

    clickOpenMenu() {
        this.setState({ openedMenu: !this.state.openedMenu })
    }

    handleScroll = () => {
        const pixelsToShowMenuWhite = this.props.pixelsToShowMenuWhite

        if (window.scrollY <= pixelsToShowMenuWhite) {
            this.setState({ whiteBackground: false })
        } else if (!this.state.showWhiteMenu) {
            this.setState({ whiteBackground: true })
        }
    }

    componentWillUnmount() {
        if(this.props.mutableMenu) {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }

    componentDidMount() {
        if(this.props.mutableMenu) {
            window.addEventListener('scroll', this.handleScroll)
        }
    }

    isTopBarVisible() {
        // return !Cookies.get('closed_newsletter_top_bar')
        return false
    }

    getMexpMenu() {
        const whiteBg = this.state.whiteBackground
        const purple = this.props.purple

        return (<nav className={cx('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin')}>
            <div className='container menu-nav-container mexp-menu'>
                <Link href='/experience' className='navbar-logo' title='Ir para a página principal.'>
                    <Picture className='logo-mercos-experience' src={`/images/experience/logo-mexp-${whiteBg ? 'gp' : purple ? 'pw' : 'gw'}.svg`} alt='Logo da Mercos.'/>
                </Link>
                <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                    <Picture src={this.state.openedMenu ? '/images/icon-cross-gray.svg' : `/images/icon-menu-sandwich-${whiteBg ? 'green' : 'white'}.svg`} alt='Botão para visualizar o menu mobile.' />
                </Button>
                <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                    <ul className='navbar-nav navbar-mobile'>
                        <MenuItem color='linkDark' type='mobile' href='/experience#home' title='Ir para a página principal.'>Home</MenuItem>
                        <MenuItem color='linkDark' type='mobile' href='/experience#sobre' title='Saber mais sobre o evento.'>Sobre</MenuItem>
                        <MenuItem color='linkDark' type='mobile' href='/experience#palestrantes' title='Conhecer os palestrantes já confirmados.'>Palestrantes</MenuItem>
                        <MenuItem color='linkDark' type='mobile' href='/experience/ingressos' title='Comprar agora meu ingresso.'>Ingressos</MenuItem>
                        <MenuItem color='linkDark' type='mobile' href='/experience/duvidas' title='Tire suas dúvidas sobre o Mercos Experience.'>Dúvidas</MenuItem>
                        <MenuItem color='linkDark' type='mobile' href='/experience/expositores' title='Quero expor no Mercos Experience.'>Expositores</MenuItem>
                        <MenuItem color='linkDark' type='mobile' href='/experience/onde-ficar' title='Saiba onde ficar hospedado e quais as atividades da região.'>Onde ficar</MenuItem>
                        <hr className='divider-menu'/>
                        <MenuItem color='linkDark' {...(purple && {className: 'purple'})} type='button' model='success' href='/experience/ingressos/' title='Compre agora seu ingresso.'>COMPRAR AGORA</MenuItem>
                    </ul>
                </div>
                <div className='d-none d-lg-block'>
                    <ul className='navbar-nav'>
                        <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/experience#home' title='Ir para a página principal.'>Home</MenuItem>
                        <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/experience#sobre' title='Saber mais sobre o evento.'>Sobre</MenuItem>
                        <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/experience#palestrantes' title='Conhecer os palestrantes já confirmados.'>Palestrantes</MenuItem>
                        <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/experience/expositores' title='Quero expor no Mercos Experience.'>Expositores</MenuItem>
                        <MenuItem {...(whiteBg && {color: 'linkDark'})} href='.' title='Tenho dúvidas sobre o Mercos Experience.' subItems={participantsSubItems}>Participantes</MenuItem>
                        <MenuItem {...(whiteBg && {color: 'linkDark'})} className={cx('extended-margin', purple && 'purple')} model='success' type='button' href='/experience/ingressos' title='Compre agora seu ingresso.'>COMPRAR AGORA</MenuItem>
                    </ul>
                </div>
            </div>
        </nav>)
    }

    getBlogMenu() {
        const whiteBg = this.state.whiteBackground

        return (
            <nav className={cx('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin')}>
                <div className='container menu-nav-container blog-menu'>
                    <Link href='/blog' className='navbar-logo' title='Ir para a página principal.'>
                        <Picture className='logo-mercos-blog' src={whiteBg ? '/images/blog/logo-mercos-blog-gp.png' : '/images/blog/logo-mercos-blog-gw.png'} alt='Logo da Mercos.'/>
                    </Link>
                    <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                        <Picture src={this.state.openedMenu ? '/images/icon-cross-gray.svg' : `/images/icon-menu-sandwich-${whiteBg ? 'green' : 'white'}.svg`} alt='Botão para visualizar o menu mobile.' />
                    </Button>
                    <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                        <ul className='navbar-nav navbar-mobile'>
                            <MenuItem color='linkDark' type='mobile' href='/blog/representante-comercial' title='Conheça nosso conteúdo para representantes comerciais'>Representante</MenuItem>
                            <MenuItem color='linkDark' type='mobile' href='/blog/gestor-comercial' title='Conheça nosso conteúdo para gestor comercial'>Gestor Comercial</MenuItem>
                            <MenuItem color='linkDark' type='mobile' href='/mercoscast' title='Ouça nosso podcast.'>Mercoscast</MenuItem>
                            <MenuItem color='linkDark' type='mobile' href='/blog/treinamentos' title='Conheça nosso conteúdo para treinamento'>Treinamentos</MenuItem>
                            <hr className='divider-menu'/>
                            <MenuItem color='linkDark' type='button' model='success' href={`/sobre/${this.state.compoundUtmUrl}`} title='Conheça a Mercos.'>CONHEÇA A MERCOS</MenuItem>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'>
                        <ul className='navbar-nav'>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} href='.' title='Conheça nosso conteúdo' subItems={videosSubItems}>Videos</MenuItem>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/blog/representante-comercial' title='Conheça nosso conteúdo para representantes comerciais'>Representante</MenuItem>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/blog/gestor-comercial' title='Conheça nosso conteúdo para gestor comercial'>Gestor Comercial</MenuItem>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/blog/treinamentos' title='Conheça nosso conteúdo para treinamento'>Treinamentos</MenuItem>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} className='extended-margin-blog' type='button' href={`/sobre/${this.state.compoundUtmUrl}`} target='_blank' title='Cadastre-se no Mercos!'>Conheça a Mercos</MenuItem>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    getMercoscastMenu() {
        const whiteBg = this.state.whiteBackground

        return (
            <nav className={cx('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin')}>
                <div className='container menu-nav-container mercoscast-menu'>
                    <Link href='/mercoscast' className='navbar-logo' title='Ir para a página principal.'>
                        <Picture className='logo-mercos-cast' src={whiteBg ? '/images/logo-mercoscast-pg.svg' : '/images/logo-mercoscast-pw.svg'} alt='Logo da Mercos.'/>
                    </Link>
                    <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                        <Picture src={this.state.openedMenu ? '/images/icon-cross-gray.svg' : `/images/icon-menu-sandwich-${whiteBg ? 'green' : 'white'}.svg`} alt='Botão para visualizar o menu mobile.' />
                    </Button>
                    <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                        <ul className='navbar-nav navbar-mobile'>
                            <MenuItem color='linkDark' type='mobile' href='/blog' title='Conheça nosso blog.'>Mercos Blog</MenuItem>
                            <hr className='divider-menu'/>
                            <MenuItem color='linkDark' type='button' model='success' href={`/sobre/${this.state.compoundUtmUrl}`} title='Conheça a Mercos.'>CONHEÇA A MERCOS</MenuItem>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'>
                        <ul className='navbar-nav'>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/blog' title='Conheça nosso blog.'>Mercos Blog</MenuItem>
                            <MenuItem {...(!whiteBg && {color: 'purple'})} className='extended-margin' type='button' href={`/sobre/${this.state.compoundUtmUrl}`} target='_blank' title='Cadastre-se no Mercos!'>Conheça a Mercos</MenuItem>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    getMarketplaceMenu() {
        return (
            <nav className={cx('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1 bg-white border-bottom shadow-sm menu-topo-branco', this.props.logoOnly && 'logo-only', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin')}>
                <div className={cx('container menu-nav-container marketplace-menu')}>
                    <Link href='/' className='navbar-logo' title='Ir para a página principal da Mercos.'>
                        <Picture className='logo-mercos' src='/images/site/logo-mercos-mp-colored.png' alt='Logo da Mercos.'/>
                    </Link>
                    <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                        <Picture src={this.state.openedMenu ? '/images/icon-cross-gray.svg' : `/images/icon-menu-sandwich-green.svg`} alt='Botão para visualizar o menu mobile.'/>
                    </Button>
                    <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                        <ul className='navbar-nav navbar-mobile'>
                            <MenuItem color='linkDark' type='mobile' href='/' title='Página inicial.'>Home</MenuItem>
                            <MenuItem color='linkDark' type='mobile' href={`/parceiros/${this.state.compoundUtmUrl}`} target='_blank' title='Conheça o programa de parceiros da Mercos.'>Programa de parceiros</MenuItem>
                            <MenuItem color='linkDark' type='mobile' href={`https://blog.mercos.com/${this.state.compoundUtmUrl}`} target='_blank' title='Conheça o blog da Mercos.'>Mercos Blog</MenuItem>
                            <hr className='divider-menu'/>
                            <PartnerContactModal className='menu-cta-button' size='small' model='outline'/>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'>
                        <ul className='navbar-nav'>
                            <MenuItem color='linkDark' href='/' title='Página inicial.'>Home</MenuItem>
                            <MenuItem color='linkDark' href={`/parceiros/${this.state.compoundUtmUrl}`} target='_blank' title='Conheça o programa de parceiros da Mercos.'>Programa de parceiros</MenuItem>
                            <MenuItem color='linkDark' href={`https://blog.mercos.com/${this.state.compoundUtmUrl}`} target='_blank' title='Conheça o blog da Mercos.'>Mercos Blog</MenuItem>
                            <PartnerContactModal className='menu-cta-button' size='small' model='outline'/>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    getSiteMenu() {
        const whiteBg = this.state.whiteBackground
        const loginOnly = this.props.loginOnly
        const regularLogo = this.props.regularLogo

        return (
            <nav className={cx('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin')}>
                <div className={cx('container menu-nav-container')}>
                    <Link href='/' className='navbar-logo' title='Ir para a página principal.'>
                        {regularLogo ?
                            <Picture className='logo-mercos' src={whiteBg ? '/images/site/logo-mercos-colored.svg' : '/images/logo_mercos_footer.svg'} alt='Logo da Mercos.'/>
                            :
                            <Picture className='logo-mercos' src={whiteBg ? '/images/site/logo-mercos-colored.svg' : '/images/logo-mercos-white.svg'} alt='Logo da Mercos.'/>
                        }
                    </Link>
                    <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                        <Picture src={this.state.openedMenu ? '/images/icon-cross-gray.svg' : `/images/icon-menu-sandwich-${whiteBg ? 'green' : 'white'}.svg`} alt='Botão para visualizar o menu mobile.' />
                    </Button>
                    <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                        <ul className='navbar-nav navbar-mobile'>
                            {!loginOnly && <Fragment>
                                <MenuItem color='linkDark' type='mobile' href='/' title='Página inicial da Mercos.'>Home</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/industrias' title='Veja como o Mercos pode potencializar sua Indústria.'>Indústrias</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/distribuidoras' title='Veja como o Mercos pode potencializar sua Distribuidora.'>Distribuidoras</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/representantes-comerciais' title='Veja como o Mercos pode potencializar o Representante Comercial.'>Representantes</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/planos-e-precos' title='Conheça nossos Planos e Preços.'>Planos e Preços</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/parceiros' title='Conheça nosso programa de Parceiros.'>Parceiros</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/blog' title='Conheça nosso conteúdo.'>Conteúdo</MenuItem>
                                <MenuItem color='linkDark' type='mobile' href='/sobre' title='Saiba mais sobre a Mercos.'>Sobre</MenuItem>
                                <hr className='divider-menu'/>
                            </Fragment>}
                            <MenuItem color='linkDark' type='mobile' onClick={() => redirectWithCookies('https://app.mercos.com/login/')} href='#' title='Acesse o Mercos!'>Entrar</MenuItem>
                            <MenuItem color='linkDark' type='button' model='success' onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')} href='#' title='Cadastre-se no Mercos.'>CADASTRE-SE</MenuItem>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'>
                        <ul className='navbar-nav'>
                            {!loginOnly && <Fragment>
                                <MenuItem {...(whiteBg && {color: 'linkDark'})} href='.' title='Conheça o Mercos.' subItems={softwareSubItems}>Software</MenuItem>
                                <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/planos-e-precos' title='Conheça nossos Planos e Preços.'>Planos e Preços</MenuItem>
                                <MenuItem {...(whiteBg && {color: 'linkDark'})} href='.' title='Saiba mais sobre nossos parceiros.' subItems={partnersSubItems}>Parceiros</MenuItem>
                                <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/blog' title='Conheça nosso conteúdo.'>Conteúdo</MenuItem>
                                <MenuItem {...(whiteBg && {color: 'linkDark'})} href='/sobre' title='Saiba mais sobre a Mercos.'>Sobre</MenuItem>
                            </Fragment>}
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} className='extended-margin' onClick={() => redirectWithCookies('https://app.mercos.com/login/')} href='#' title='Acesse o Mercos!'>Entrar</MenuItem>
                            <MenuItem {...(whiteBg && {color: 'linkDark'})} type='button' onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')} href='#' title='Cadastre-se no Mercos!'>CADASTRE-SE</MenuItem>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    getNewHomeSiteMenu() {
        const whiteBg = this.state.whiteBackground
        const loginOnly = this.props.loginOnly

        return (
            <nav className={cx('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin')}>
                <div className={cx('container menu-nav-container new-home-container')}>
                    <Link href='/' className='navbar-logo' title='Ir para a página principal.'>
                        <div className={whiteBg ? 'logo-mercos-new-home-white-bg' : 'logo-mercos-new-home'} />
                    </Link>
                    <Button model='no-borders' className='menu-button d-lg-none' ariaLabel='Botão de acesso ao menu mobile.' onClick={() => this.clickOpenMenu()}>
                        <Picture src={this.state.openedMenu ? '/images/icon-cross-gray.svg' : `/images/icon-menu-sandwich-${whiteBg ? 'green' : 'white'}.svg`} alt='Botão para visualizar o menu mobile.' />
                    </Button>
                    <div className={cx('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none')}>
                        <ul className='navbar-nav navbar-mobile'>
                            {!loginOnly && <Fragment>
                                <MenuItem color='linkBlack'  className='highlight' href='/' title='Página inicial da Mercos.'>Home</MenuItem>
                                <MenuItem color='linkBlack'  href='.' title='Conheça o Mercos.' newSubItems={softwareSubItems}>Software</MenuItem>
                                <MenuItem color='linkBlack'  className='highlight'  href='/planos-e-precos' title='Conheça nossos Planos e Preços.'>Planos e Preços</MenuItem>
                                <MenuItem color='linkBlack'  href='.' title='Saiba mais sobre nossos parceiros.' newSubItems={partnersSubItems}>Integrações</MenuItem>
                                <MenuItem color='linkBlack'  href='.' title='Conheça nosso conteúdo.' newSubItems={conteudoSubItems}>Conteúdo</MenuItem>
                            </Fragment>}
                            <MenuItem type='button' className='button-menu-mobile' model='success' onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')} href='#' title='Cadastre-se no Mercos.'>comece grátis</MenuItem>
                            <MenuItem color='linkBlack' model='outline' className={cx('highlight', 'link-menu')} onClick={() => redirectWithCookies('https://app.mercos.com/login/')} href='#' title='Acesse o Mercos!'>Ja possui conta? acesse aqui</MenuItem>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'>
                        <ul className='navbar-nav new-home-navbar'>
                            {!loginOnly && <Fragment >
                                <MenuItem color='linkBlack'  href='.' title='Conheça o Mercos.' newSubItems={softwareSubItems}>Software</MenuItem>
                                <MenuItem color='linkBlack' className='highlight' href='/planos-e-precos' title='Conheça nossos Planos e Preços.'>Planos e Preços</MenuItem>
                                <MenuItem color='linkBlack' href='.' title='Saiba mais sobre nossos parceiros.' newSubItems={partnersSubItems}>Integrações</MenuItem>
                                <MenuItem color='linkBlack' href='.' title='Conheça nosso conteúdo.' newSubItems={conteudoSubItems}>Conteúdo</MenuItem>
                            </Fragment>}
                            <MenuItem
                                {...(whiteBg && {color: 'linkBlack'})}
                                className={cx('menu-item-enter', !whiteBg && 'menu-item-enter-white')}
                                shake
                                onClick={() => redirectWithCookies('https://app.mercos.com/login/')}
                                href='#'
                                title='Acesse o Mercos!'
                            >
                                Entrar
                            </MenuItem>
                            <MenuItem className={whiteBg ? 'button-menu-home-bg-white': 'button-menu-home'} shake type='button' onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')} href='#' title='Cadastre-se no Mercos!'>comece grátis</MenuItem>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    getSiteNavProps() {
        const { loginOnly, mutableMenu, pixelsToShowMenuWhite, isNewHome, whiteBackground } = this.props
        const forceSolid = !!whiteBackground && !mutableMenu
        const scrollAwareBackground = (mutableMenu || isNewHome) && !forceSolid

        return {
            loginOnly: !!loginOnly,
            logoOnly: !!this.props.logoOnly,
            pixelsToShowMenuWhite: pixelsToShowMenuWhite || 50,
            transparentOnTop: scrollAwareBackground,
            whiteBackground: forceSolid,
        }
    }

    render() {
        return (
            <Fragment>
                {this.props.isBlog ?
                    this.getBlogMenu()
                :
                this.props.isMercoscast ?
                    this.getMercoscastMenu()
                :
                this.props.isMexp ?
                    this.getMexpMenu()
                :
                this.props.isMarketplace ?
                    this.getMarketplaceMenu()
                :
                    <SiteNav {...this.getSiteNavProps()} />
                }
            </Fragment>
        )
    }
}

Menu.propTypes = {
    bigPadding: PropTypes.bool,
    whiteBackground: PropTypes.bool,
    logoOnly: PropTypes.bool,
    mutableMenu: PropTypes.bool,
    pixelsToShowMenuWhite: PropTypes.number,
    isNewHome: PropTypes.bool,
}

Menu.defaultProps = {
    bigPadding: false,
    whiteBackground: false,
    logoOnly: false,
    mutableMenu: false,
    pixelsToShowMenuWhite: 100
}

export default Menu



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Menu/Menu.jsx